import { render } from "./GraduationStatusByProgram.vue?vue&type=template&id=d8696b1a"
import script from "./GraduationStatusByProgram.vue?vue&type=script&lang=js"
export * from "./GraduationStatusByProgram.vue?vue&type=script&lang=js"
script.render = render

export default script